@if (control) {
  <div class="pegi-container">
    @for (code of pegiCodes; track code) {
      <!-- <mat-checkbox class="checkbox d-block" [formControlName]="key">
      {{"form.field.pegi." + key | transloco}}
    </mat-checkbox> -->
      <div class="pegi-checkbox cta-btn" (click)="togglePegiCode(code)" [class.active]="isPegiActive(code)">
        <div class="pegi-symbol" [inlineSVG]="'/icons/pegi/pegi-' + code + '.svg'"></div>
      </div>
    }
  </div>
}
